module.exports = __webpack_public_path__ + "static/media/Cookie_not_locked.ccc2aaa2.svg";